// extracted by mini-css-extract-plugin
module.exports = {"cpBox":"cpBubble_cpBox__AyPFA","cpAvatar":"cpBubble_cpAvatar__xZ2EE","date":"cpBubble_date__Il6eI"};